import axios from 'axios';
import { useAuthHeader, useAuthUser } from "../../../../Services/Auth/sessionAuth";
import Utilisateur from "../../../../Models/Utilisateur";
import { useState } from "react";
import { Button, Form, Tabs, Space, Spin, Checkbox } from 'antd';
import Table from '../../../TableResizable';
import type { TabsProps } from 'antd';
import Demand from '../../../../Models/MDEMANDCHQ';
import { Box, Typography } from '@mui/material';
import SweetAlert from "sweetalert2";
import InputForm from "../../../InputT";
import SearchModal from "../../../SearchModal";
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import ParamsPicklist from "../../../../Types/ParamsPicklist"
import Tab1 from './Tab1';
import SearInputG from "../../../SearchInput"
import Data from '../../../../Data/Data.json'
import { Radio } from 'antd';
import React from "react";

//pour le tableau
import DataType from "../../../../Functions/Traitement/DataPeriodMbloquer";
import { ColumnGroupType, ColumnsType } from 'antd/es/table';
import { Crypter } from "../../../../Functions/Security/Crypter";
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import formatDate from '../../../../Functions/Traitement/fomatDate';
import RadioBox from "../../../Radiox";
import Tab4 from './Tab4';
import SelectOption from '../../../SelectOption';
import DataSelect from '../../../../Types/DataSelect';
import CLIENT from '../../../../Models/Client';
import { Code } from '@mui/icons-material';
import SearInputM from '../../../SearchModal';
import SelectOption2 from '../../../SelectOption2';
import { executionAsyncResource } from 'async_hooks';
import SelectOption3 from '../../../selectoption3';



let searchCsion: ParamsPicklist = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }


const dataOption: DataSelect[] = [
    { label: "TENIR A MA DISPOSITION AU GUICHET", value: "TENIR AU GUICHET" },
    { label: "L'EXPEDIER A L'ADRESSE DU MEMBRE", value: "EXPEDIER AU MEMBRE" },
    { label: "REMETTRE AU MEMBRE", value: "REMETTRE AU MEMBRE" }
]
const dataOption2: DataSelect[] = [
    { label: "25", value: "25" },
    { label: "50", value: "50" },
    { label: "100", value: "100" }
]

const DemandCHQ = () => {

    // USER SESSION
    const [form] = Form.useForm();
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false)
    const [ajoutActve, setAjoutActif] = useState(false)
    const [donnees, setData] = useState<DataType[]>([]);
    const [sbmit, setSbmit] = useState("")
    const authHeader = useAuthHeader()
    const [radiostate, setradio] = useState(false);
    const [Idlibell, setIdlibell] = useState(false);


    //vérification de la date de naissance qui doit etre supérieur à la date actuel
    const [Numcli, SetNumcli] = useState();
    const handleChangeClient = () => {
        form.setFieldValue("NUMCPT", '')
        form.setFieldValue("lib_NUMCPT", '')
        let Numcli = form.getFieldValue("NUMCLI");
        SetNumcli(Numcli);
        //alert(Numcli);

        // setlim(form.getFieldValue("NUMCLI"))
        // form.setFieldValue("NBCHQR", 1);
        // consultClient()
    };

    let searchNumCompte: ParamsPicklist = { CodeAgence: Numcli ? Numcli : "JH", Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: "NUMCLI", colfiltre: "AGCCPT", valfiltre: Perss.codage, Choix: 22 }


    // filtrer les comptes 
    const [Lim, setlim] = useState('aba')
    //let searchCompte: ParamsPicklist = { CodeAgence: Lim, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: 'NUMCLI', Choix: 22 }
    let searchCompte: ParamsPicklist = { CodeAgence: Perss.codage, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: 'AGCCPT', colfiltre: "NUMCLI", valfiltre: Lim, Choix: 22 }


    let searchDmandCHQ: ParamsPicklist = { CodeAgence: Perss.codage, Table: "DEMANDECHQ", Colonne1: "NUMDEMANDE", Colonne2: "NOMCPT", Colagence: 'codeage', colfiltre: "", valfiltre: '', Choix: 22 }
    // let searchClient: ParamsPicklist = { CodeAgence: Perss.codage, Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: "CODAGE", colfiltre: "", valfiltre: '', Choix: 22 }
      let searchClient: ParamsPicklist = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '', colfiltre: "", valfiltre: '', Choix: 22 }


    const Getselectcli = (value: any) => {
        setlim(form.getFieldValue("NUMCLI"))
        form.setFieldValue("NBCHQR", 1);
        consultClient()
    }

    const [radioaCheck, setRadioaCheck] = useState(false)

    // usestate 
    const [Consult, setConsult] = useState(false);
    const [Ajout, setAjout] = useState(false);
    const [Modif, setModif] = useState(true);
    const [Enreg, setEnreg] = useState(true);
    const [Annul, setAnnul] = useState(true);
    const [Actualise, setActual] = useState(true);
    const [Supp, setSupprim] = useState(true);

    // handle
    function HandleConsult() {
        setConsult(true);
        setAjout(true);
        setModif(false);
        setAnnul(false);
        setIdlibell(true)
    }

    function HandleAjout() {
        setConsult(true);
        setAjout(true);
        setEnreg(false);
        setActual(false);
        setAnnul(false);
        setAjoutActif(true)
        setIdlibell(true)
    }

    function HandleModif() {
        setModif(true);
        setEnreg(false);
        setAjoutActif(true)
    }

    function HandleEnreg() {

        HandleAnnul();
    }

    function HandleAnnul() {
        setAjout(false);
        setConsult(false);
        setModif(true);
        setEnreg(true);
        setActual(true);
        setAnnul(true);
        setAjoutActif(false);
        form.resetFields();
        setSbmit('');
        setRadioaCheck(false)
        setradio(false);
        localStorage.setItem(Data.LocalVariable.reset, "1")
        localStorage.setItem(Data.LocalVariable.Mainreset, "1")
        localStorage.clear();
        setIdlibell(false)
    }

    function HandleReset() {
        form.resetFields();
    }

    function HandleSupp() {

    }

    //***************************************************************************************************/
    //********************** Function Pour Afficher les Commissions à Afficher **************************/
    function change(e: any, indexe: number) {
        let value = e.target.value as number
        var t = 0
        if (value + "" == "") {
            form.setFieldValue("MONTAN" + indexe, 0)
        } else {
            form.setFieldValue("MONTAN" + indexe, value)
        }
        for (let i = 1; i <= commissions.length; i++) {
            var tmp = parseInt(form.getFieldValue("MONTAN" + i) + "") ? parseInt(form.getFieldValue("MONTAN" + i) + "") : 0
            t = t + tmp
            //console.log(t)
        }
        //alert(t)
        form.setFieldValue("cssionApliq", t)
    }

    //***************************************************************************************************/
    //********************** Tableau pour la liste des Commissions à Afficher ***************************/
    const commissions = [
        {
            indexe: 1,
            code: "901",
            label: "FRAIS DE CHEQUIER 25 FEUILLETS"
        },
        {
            indexe: 2,
            code: "906",
            label: "FRAIS DE CHEQUIER 50 FEUILLETS"
        },
        // {
        //     indexe: 3,
        //     code: "948",
        //     label: "CION N°3/MISE EN PLACE PRET"
        // },
        // {
        //     indexe: 4,
        //     code: "949",
        //     label: "CION N°4/MISE EN PLACE PRET"
        // }
    ]

    //***************************************************************************************************/
    //********************** Usestate Pour La gestion des états des Montants Commissions ****************/
    const [checked1, setChecked1] = React.useState(true);
    const [checked2, setChecked2] = React.useState(true);
    const [checked3, setChecked3] = React.useState(true);
    const [checked4, setChecked4] = React.useState(true);

    const [loadMont1, setLoadMont1] = React.useState(false);
    const [loadMont2, setLoadMont2] = React.useState(false);
    const [loadMont3, setLoadMont3] = React.useState(false);
    const [loadMont4, setLoadMont4] = React.useState(false);

    const tabCheck = [checked1, checked2, checked3, checked4]

    //***************************************************************************************************/
    //********************** Function Pour la gestion des Montant des commissions ***********************/
    const onChange = (cssion: any) => {

        let montant = -1;

        if (montant) {

            let indexe = cssion.indexe
            let mont = 0;
            switch (indexe) {
                case 1:
                    setChecked1(!checked1)
                    setLoadMont1(true);
                    break;
                case 2:
                    setChecked2(!checked2)
                    setLoadMont2(true);
                    break;
                case 3:
                    setChecked3(!checked3)
                    setLoadMont3(true);
                    break;
                case 4:
                    setChecked4(!checked4)
                    setLoadMont4(true);
                    break;
                default:
                    break;
            }

            const datat: DataType[] = [];
            var datas = { commission: null }
            //var data = { CodeAgence: searchMontantCsion?.CodeAgence, Table: searchMontantCsion?.Table, Colonne1: searchMontantCsion?.Colonne1, Colonne2: searchMontantCsion?.Colonne2, Colagence: searchMontantCsion?.Colagence, Init: cssion.code, choix: searchMontantCsion?.Choix }
            var com = { "CodOpe": cssion.code, Montant: montant, "CodAge": Perss.codage }

            var config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.GetCommission,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authHeader(),
                    'CypherCommission': Crypter.encrypt(JSON.stringify(com))
                }
            };
            axios(config)
                .then((response) => {
                    //alert('ok')
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                        if (res.StatutCode == 200) {
                            datas = res.Result.Table[0];

                            switch (indexe) {
                                case 1:
                                    if (!checked1) {
                                        mont = form.getFieldValue('MONTAN' + indexe) ? form.getFieldValue('MONTAN' + indexe) : 0
                                        form.setFieldValue('MONTAN' + indexe, "0")
                                    } else {
                                        form.setFieldValue("MONTAN" + indexe, datas.commission)
                                    }
                                    setChecked1(!checked1)
                                    break;
                                case 2:
                                    if (!checked2) {
                                        mont = form.getFieldValue('MONTAN' + indexe) ? form.getFieldValue('MONTAN' + indexe) : 0
                                        form.setFieldValue('MONTAN' + indexe, "0")
                                    } else {
                                        form.setFieldValue("MONTAN" + indexe, datas.commission)
                                    }
                                    setChecked2(!checked2)
                                    break;
                                case 3:
                                    if (!checked3) {
                                        mont = form.getFieldValue('MONTAN' + indexe) ? form.getFieldValue('MONTAN' + indexe) : 0
                                        form.setFieldValue('MONTAN' + indexe, "0")
                                    } else {
                                        form.setFieldValue("MONTAN" + indexe, datas.commission)
                                    }
                                    setChecked3(!checked3)
                                    break;
                                case 4:
                                    if (!checked4) {
                                        mont = form.getFieldValue('MONTAN' + indexe) ? form.getFieldValue('MONTAN' + indexe) : 0
                                        form.setFieldValue('MONTAN' + indexe, "0")
                                    } else {
                                        form.setFieldValue("MONTAN" + indexe, datas.commission)
                                    }
                                    setChecked4(!checked4)
                                    break;

                                default:
                                    break;
                            }
                            var montant = parseInt(form.getFieldValue('MONTAN' + indexe) + "") ? parseInt(form.getFieldValue('MONTAN' + indexe) + "") : 0
                            var total = parseInt(form.getFieldValue("cssionApliq") + "") ? parseInt(form.getFieldValue("cssionApliq") + "") : 0


                            switch (indexe) {
                                case 1:
                                    if (checked1) {
                                        total = total + montant
                                    } else {
                                        total = total - mont
                                    }
                                    break;
                                case 2:
                                    if (checked2) {
                                        total = total + montant
                                    } else {
                                        total = total - mont
                                    }
                                    break;
                                case 3:
                                    if (checked3) {
                                        total = total + montant
                                    } else {
                                        total = total - mont
                                    }
                                    break;
                                case 4:
                                    if (checked4) {
                                        total = total + montant
                                    } else {
                                        total = total - mont
                                    }
                                    break;
                                default:
                                    break;
                            }



                            form.setFieldValue("cssionApliq", total)
                            //SetData([{Code: datas.CODOPE, Libelle : datas.MONFIX, key: 0}])
                        }
                    }
                    //setLoadMont1(false);

                }).catch((error) => {
                    //console.log(error)
                    setChecked1(true);
                    setChecked2(true);
                    setChecked3(true);
                    setChecked4(true);


                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                }).finally(() => {
                    switch (indexe) {
                        case 1:
                            setLoadMont1(false);
                            break;
                        case 2:
                            setLoadMont2(false);
                            break;
                        case 3:
                            setLoadMont3(false);
                            break;
                        case 4:
                            setLoadMont4(false);
                            break;
                        // case 5:
                        //   setLoadMont5(false);
                        //   break;

                        default:
                            break;
                    }
                })
        }
        else {
            SweetAlert.fire({ title: "Veillez saisir le montant de la demande de prêt", icon: "warning" })
        }
    };


    // Gestion des Items 
    const items: TabsProps['items'] = [
        {
            key: '2',
            label: (
                <span id='Tab'>
                    <UserOutlined />
                    Demande chèque
                </span>
            ),
            children: <>
                <div className='tabItem' >
                    <div style={{ display: 'block flow' }}  >
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >
                            <Box fontStyle="inherit" className='border-left'>
                                <legend> Demande de chéquier </legend>

                                <fieldset className="bordure1" style={{ marginTop: -10 }}>
                                    <Box style={{ display: 'flex' }}>
                                        <Box style={{ width: '40%' }}>
                                            <Box style={{ marginTop: -5 }}>
                                                <SearInputG notRequired dissabledCode={Idlibell} width={6} Titre="Recherche" label="Réference" name="NUMDEMANDE" Parametre={searchDmandCHQ} Taille1={'100%'} Taille2={0} form={form} />
                                            </Box>
                                            <Box style={{ marginTop: -10 }}>
                                                <SearchModal width={6} Titre="Recherche" label="ID client" name="NUMCLI" Parametre={searchClient} Taille1={'100%'} ExecuteafterSelect1={Getselectcli} ExecuteafterSelect2={handleChangeClient} Taille2={'100%'} form={form} />
                                            </Box>
                                            <Form.Item name="NUMCPT" className='bordure' label="N° comptes" style={{ marginTop: -10,width:'100%' }}  labelCol={{ span: 6, offset: 0 ,style:{whiteSpace: 'pre-wrap'}}}>
                                                <SelectOption2 width={10} Size="middle" name="NUMCPT" Parametre={searchNumCompte} taille={'90%'} />
                                            </Form.Item>
                                            {/* <Box style={{ marginTop: -10 }}>*/}
                                                {/* <SelectOption2 width={6} Size="middle" label="N° comptes" name="NUMCPT" Parametre={searchNumCompte} /> */}
                                                {/* <SearchModal width={6} Titre="Recherche" label="N° compte" name="NUMCPT" Parametre={searchCompte} Taille1={'100%'} Taille2={'100%'} form={form} /> */}
                                                {/* <SelectOption2 marginTop={'10px'} minWidth={200} labelWidth={6} Size="middle" label="N° comptes" name="NUMCPT" Parametre={searchNumCompte} /> */}
                                                {/*  < SelectOption3 Parametre={searchNumCompte}  width={10} label="N° comptes" Size={'middle'} name="NUMCPT" /> */}
                                            {/* </Box> */}
                                            <Box style={{ marginTop: -10, width: '100%' }}>
                                                <Form.Item style={{ width: '100%', marginTop: -15, marginBottom: -15 }} >
                                                    < SelectOption Option={dataOption2} width={10} label="Nbre chèques/chéquier" Size={'100%'} name="NBCHQS" />
                                                </Form.Item>
                                            </Box>
                                            <Box style={{ marginBottom: 10, width: '100%' }} >
                                                <SelectOption Option={dataOption} width={6} label='Destination' Size={15} name='DESCHQ' />
                                            </Box>
                                        </Box>
                                        <Box style={{ width: '50%' }}>
                                            <Box style={{ marginTop: -5, width: '100%' }} >
                                                <InputForm notRequired disabled={true} width={5} label="Ville" type="texte" name="VILCLI" />
                                            </Box>
                                            <Box style={{ marginTop: -10, width: '100%' }}>
                                                <InputForm notRequired disabled={true} width={5} label="Fax" type="texte" name="FAXCLI" />
                                            </Box>
                                            <Box style={{ marginTop: -10, width: '100%' }}>
                                                <InputForm notRequired disabled={true} width={5} label="Téléphone" type="number" name="TELCLI" />
                                            </Box>
                                            <Box style={{ marginTop: -10, marginBottom: -10, width: '100%' }}>
                                                <InputForm notRequired disabled={true} width={5} label="Boîte postale" type="texte" name="BPTCLI" />
                                            </Box>
                                            <Box style={{ marginTop: -10, marginBottom: -15, width: '100%' }}>
                                                <InputForm disabled={true} value={1} width={5} label="Nbre chequier" type="number" name="NBCHQR" />
                                            </Box>
                                        </Box>
                                    </Box>
                                </fieldset>

                                <fieldset className="bordure1" style={{ marginTop: 0 }}>
                                    <Box style={{ display: 'flex' }}>
                                        <Box fontStyle="inherit" >
                                            {commissions.map((cssion, indexe) => (
                                                <Box marginTop={1} >
                                                    <Checkbox style={{ marginTop: -5 }} checked={!tabCheck[indexe]} onChange={() => { onChange(cssion) }}>
                                                        <SearInputM width={6} defaultCode={cssion.code} defaultLibelle={cssion.label} form={form} Titre={'Recherche Type Commission ' + (indexe + 1)} label={'Commission.. ' + (indexe + 1)} name={'CODOP' + (indexe + 1)} Parametre={searchCsion} />
                                                    </Checkbox>
                                                </Box>
                                            ))}
                                        </Box>
                                        <Box>
                                            <Box style={{ marginTop: 5 }}>
                                                <InputForm min={0} defaultValue='0' disabled={true} onChange={(e) => { change(e, 1) }} width={9} label={'Montant 1'} name={'MONTAN1'} type='number' error='mobile' />
                                            </Box>
                                            <Box style={{ marginTop: -7 }}>
                                                <InputForm min={0} defaultValue='0' disabled={true} onChange={(e) => { change(e, 2) }} width={9} label={'Montant 2'} name={'MONTAN2'} type='number' error='mobile' />
                                            </Box>
                                        </Box>
                                    </Box>
                                </fieldset>
                            </Box>
                        </Box>
                    </div>
                </div >

            </>
        },
    ];


    // function consult des elements du client 
    function consultClient() {

        let data = Crypter.encrypt(form.getFieldValue("NUMCLI"));
        let clearNumcli = form.getFieldValue("NUMCLI")

        //alert("clearNumcli : "+clearNumcli)
        if (data.length != 0) {
            //initialiazeButton()
            setLoading(true)
            form.resetFields()
            form.setFieldValue("NUMCLI", clearNumcli)
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.GetClient,
                headers: {
                    'CypherNumcli': data,
                    'Authorization': authHeader(),
                    'Content-Type': 'application/json'
                },
            };
            axios.request(config)
                .then((response) => {
                    setLoading(false);
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data));

                        if (res.StatutCode == 200) {
                            let datas = res.Result.Table[0]
                            //console.log(res)
                            if (res.Result.Table.length > 0) {

                                form.setFieldsValue(res.Result.Table[0]);
                                //console.log(datas);
                                form.setFieldValue('VILCLI', datas.lib_vilCli)
                                form.setFieldValue('FAXCLI', (datas.FaxCli));
                                form.setFieldValue('TELCLI', (datas.telCli));
                                form.setFieldValue("BpCli", datas.BpCli)
                                form.setFieldValue("lib_vilCli", datas.DATCRE ? (new Date(datas.DATCRE.substring(0, 10))).toLocaleDateString("fr") : '')

                                form.setFieldValue('VILCLI', datas.lib_vilCli)
                                form.setFieldValue('FAXCLI', (datas.FaxCli));
                                form.setFieldValue('TELCLI', (datas.telCli));
                                form.setFieldValue("BpCli", datas.BpCli);
                                form.setFieldValue("NBCHQR", 1);
                                form.setFieldValue("lib_NUMCLI", datas.NOMCLI)
                                form.setFieldValue("NUMCPT", String(datas.NUMCPT))
                                //cunsultButton();
                                //console.log(form.getFieldsValue())

                            } else {
                                SweetAlert.fire({ title: "Warning", text: "Client not found", icon: "warning" })
                            }
                        }
                        else {
                            SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                        }
                    }
                    setLoading(false)
                })
                .catch((error) => {
                    setLoading(false);
                    console.log(error)
                    SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                });
        }
    }


    // function consult 
    function consult() {
        if (form.getFieldValue("NUMDEMANDE") == null) {
            SweetAlert.fire({ title: "Svp renseigner le numero de reference", icon: "warning" });
            HandleAnnul();
        } else {
            //console.log('numero :' + form.getFieldValue("NUMDEMANDE"))
            //console.log('agence :' + Perss.codage)
            let data = Crypter.encrypt(form.getFieldValue("NUMDEMANDE"));
            let codeage = Crypter.encrypt(Perss.codage)
            //alert(form.getFieldValue("NUMDEMANDE"))
            if (data.length != 0) {
                setLoading(true)
                form.resetFields()
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ReadDemandCHQ,
                    headers: {
                        'CypherREFMARQ': data,
                        'CypherCodeage': codeage,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                axios.request(config)
                    .then((response) => {
                        setLoading(false);

                        if (response.data) {
                            const res = JSON.parse(Crypter.decrypt(response.data));
                            console.log(JSON.stringify(res))
                            let DemandCHQ = res.Result.Table[0]
                            if (res.StatutCode == 200) {
                                form.setFieldsValue(DemandCHQ);
                                form.setFieldValue("lib_NUMCLI", DemandCHQ.lib_NUMCPT);
                                form.setFieldValue("NUMCPT", String(DemandCHQ.NUMCPT));
                            }
                            else {
                                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }
        }
    }




    // function Onfinish
    const onFinish = (values: any) => {
        console.log(values)
        var DemandCHQ: Demand = values
        DemandCHQ.UTIVAL = Perss.coduti

        //DemandCHQ.NBCHQS = parseInt(DemandCHQ.NBCHQS);

        if (sbmit == "add") {
            DemandCHQ.DATDEM = formatDate(Perss.datjour);
            DemandCHQ.codeage = Perss.codage;

            SweetAlert.fire({
                title: "Création d'une demande de chèque",
                text: "Voulez-vous Créer la demande de :" + String(form.getFieldValue("lib_NUMCLI")) + " ?",
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //console.log((DemandCHQ))
                    let data = Crypter.encrypt(JSON.stringify(DemandCHQ));

                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.CreateDemandCHQ,
                        headers: {
                            'CypherDEMANDCHQ': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                if (res.StatutCode == 200) {
                                    let code = res.Result

                                    if (code == "Erreur NUMCPT") {
                                        SweetAlert.fire({ title: "Warning", text: "Le numéro de compte et le numéro client ne sont pas lié :(", icon: "warning" })
                                    } else {
                                        form.resetFields()
                                        localStorage.clear()
                                        setIsSubmit(false)
                                        HandleAnnul()
                                        SweetAlert.fire({ title: res.Message, text: "Demande Enregistrer Avec Succés. Référence :" + code, icon: "success" })
                                    }

                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }

        if (sbmit == "modif") {
            DemandCHQ.DATDEM = formatDate(Perss.datjour);
            DemandCHQ.codeage = Perss.codage;

            SweetAlert.fire({
                title: "Mise à jour d'une demande de chèque",
                text: "Voulez-vous Modifier la demande de :" + values.lib_NUMCPT + " ?",
                showCancelButton: true,
                color: "green",
                confirmButtonText: "Yes",
                confirmButtonColor: "green",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //console.log((DemandCHQ))
                    let data = Crypter.encrypt(JSON.stringify(DemandCHQ));

                    let config = {
                        method: 'put',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.UpdateDemandCHQ,
                        headers: {
                            'CypherDEMANDCHQ': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                if (res.StatutCode == 200) {
                                    let code = res.Result;
                                    if (res.Message == 'IMPOSSIBLE') {
                                        HandleAnnul()
                                        form.resetFields()
                                        localStorage.clear()
                                        setIsSubmit(false)
                                        SweetAlert.fire({ title: "Warning", text: "Impossible de modifier une demande qui à traverser l'étape de validation", icon: "warning" })
                                    } else if (res.Message == 'Mise en place') {
                                        HandleAnnul()
                                        form.resetFields()
                                        localStorage.clear()
                                        setIsSubmit(false)
                                        SweetAlert.fire({ title: "Warning", text: "Impossible de modifier une demande dont on à déja fait la mise en place", icon: "warning" })
                                    } else {
                                        HandleAnnul()
                                        form.resetFields()
                                        localStorage.clear()
                                        setIsSubmit(false)
                                        SweetAlert.fire({ title: '', text: "Operation Effectuer avec succés. reference: " + res.Message, icon: "success" })
                                    }
                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
    }


    // control du forms 
    const onFinishFailed = (errorInfo: any) => {
        setLoading(true);
        setLoading(false);
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            SweetAlert.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b> {window.location.pathname}</b></Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }} >
                <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consult} onClick={() => { HandleConsult(); consult() }} type="ghost" block>
                                    Consulter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Ajout} onClick={() => { HandleAjout(); setSbmit("add") }} type="ghost" block  >
                                    Ajouter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Modif} onClick={() => { HandleModif(); setSbmit("modif") }} type="ghost" block  >
                                    Modifier
                                </Button>
                                <Button size='large' className='bt_add' disabled={Enreg} onClick={() => { }} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Supp} onClick={() => { HandleSupp(); setSbmit("supp") }} type="ghost" block>
                                    Supprimer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Actualise} onClick={() => { HandleReset() }} type="ghost" block  >
                                    Actualiser
                                </Button>
                                <Button size='large' disabled={Annul} onClick={() => { HandleAnnul() }} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>

                            <div>

                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}

export default DemandCHQ;